import Vue from 'vue'

export const weekCart = {
    state: {
        weekCart: [],
        offDays: []
    },
    mutations: {
        SET_WEEKCART(state, weekCart) {
            for(const [key, value] of Object.entries(weekCart)) {
                Vue.set(state, key, value)
            }
        },
        ADD_PRODUCT_TO_CART(state, payload) {
            Vue.set(state.weekCart, payload.idx, payload.obj)
        },
        SET_OFF_DAYS(state, offDays) {
            Vue.set(state, 'offDays', offDays)
        },
        REMOVE_ORDERS_FROM_ADDRESS(state, addressId) {
            const idsToRemove = []
            state.weekCart.forEach((order, idx) => {
                if(order.addressId === addressId) {
                    idsToRemove.push(idx)
                }
            })
            // remove from week in reverse (stack pop)
            idsToRemove.reverse().forEach(id => {
                Vue.delete(state.weekCart, id)
            })
            // assign new addressId
            state.weekCart.forEach((order, idx) => {
                if(order.addressId > addressId) {
                    Vue.set(order, 'addressId', order.addressId - 1)
                }
            })
        },
        RESET_WEEK_CART(state) {
            state.weekCart = []
            state.offDays = []
        }
    },
    actions: {
        setWeekCart({ commit }, weekCart) {
            commit('SET_WEEKCART', weekCart)
        },
        applyProductToCart({ state, commit, dispatch, getters }, payload) {
            // check if exist
            const idx = state.weekCart.findIndex(item => item.product.id === payload.product.id && item.dayInWeek === payload.dayInWeek && item.addressId === payload.addressId)

            // if amount is 0 then delete
            if(payload.amount === 0) {
                Vue.delete(state.weekCart, idx)
            } else {
                // create payload for state
                const obj = {}

                Vue.set(obj, 'product', payload.product)
                Vue.set(obj, 'amount', payload.amount)
                Vue.set(obj, 'addressId', payload.addressId)
                Vue.set(obj, 'dayInWeek', payload.dayInWeek)
                Vue.set(obj, 'draggable', payload.draggable || false)
                Vue.set(obj, 'cycleId', isNaN(payload.cycleId) ? null : payload.cycleId)
                if(payload.cycle) {
                    Vue.set(obj, 'cycle', payload.cycle)
                }
                if(payload.period) {
                    Vue.set(obj, 'period', payload.period)
                }
                if(payload.product && payload.product.net_price) {
                    Vue.set(obj, 'net_price', payload.product.net_price)
                } else if(payload.net_price) {
                    Vue.set(obj, 'net_price', payload.net_price)
                }

                if(idx === -1) {
                    commit('ADD_PRODUCT_TO_CART', {
                        idx: state.weekCart.length,
                        obj
                    })
                } else {
                    commit('ADD_PRODUCT_TO_CART', {
                        idx,
                        obj
                    })
                }
            }
            dispatch('saveState', { weekCart: state })
        },
        removeOrdersFromAddress({ state, commit, dispatch, getters }, addressId) {
            commit('REMOVE_ORDERS_FROM_ADDRESS', addressId)
            dispatch('saveState', {
                customer: getters.customer,
                weekCart: state
            })
        },
        fetchOffDays({ commit, getters }) {
            return new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/management/off_days').then(response => {
                    commit('SET_OFF_DAYS', response.data.data)
                    resolve()
                })
            })
        },
        resetWeekCart({ commit, dispatch }) {
            commit('RESET_WEEK_CART')
            dispatch('saveState', {
                weekCart: {
                    weekCart: [],
                    offDays: []
                }
            })
        }
    },
    getters: {
        weekOrders: (state) => {
            return state.weekCart
        },
        weekDayOrder: (state) => (dayInWeek, addressId) => {
            return state.weekCart.filter(item => item.dayInWeek === dayInWeek && item.addressId === addressId)
        },
        weekDayOrderSum: (state, getters, rootGetters) => (dayInWeek, addressId, onlyCartSum = false) => {
            const netPrice = rootGetters.deliveries.beforeUpsell.net_price || 0
            const result = state.weekCart.filter(item => item.dayInWeek === dayInWeek && item.addressId === addressId).reduce((previous, current) => {
                previous = previous + parseFloat((getters.packagePrice(current.product.id, current.dayInWeek, addressId) * current.amount).toFixed(2))
                return parseFloat(previous)
            }, 0)
            return onlyCartSum ? result : result + netPrice
        },
        weekDayOrderSumWithoutDiscount: (state, getters, rootGetters) => (dayInWeek, addressId) => {
            const baseNetPrice = rootGetters.deliveries.beforeUpsell.base_net_price || 0
            const result = state.weekCart.filter(item => item.dayInWeek === dayInWeek && item.addressId === addressId).reduce((previous, current) => {
                previous = previous + parseFloat((getters.packagePriceWithoutDiscount(current.product.id, addressId) * current.amount).toFixed(2))
                return parseFloat(previous)
            }, 0)
            return result + baseNetPrice
        },
        weekAmount: (state, getters) => (addressId, isOneTimeOrder = false) => {
            return state.weekCart.reduce((previous, current) => {
                if(current.addressId === addressId) {
                    previous = previous + parseFloat((getters.packagePrice(current.product.id, current.dayInWeek, addressId, isOneTimeOrder) * current.amount).toFixed(2))
                }
                return parseFloat(previous)
            }, 0)
        },
        totalAmount: (state, getters, rootGetters) => {
            const netPrice = rootGetters.deliveries.beforeUpsell.net_price || 0
            const result = state.weekCart.reduce((previous, current) => {
                previous = previous + parseFloat((getters.packagePrice(current.product.id, current.dayInWeek, current.addressId) * current.amount).toFixed(2))
                return parseFloat(previous)
            }, 0)
            return result + netPrice
        },
        totalAmountWithoutDiscount: (state, getters) => (addressId) => {
            return state.weekCart.reduce((previous, current) => {
                previous = previous + parseFloat((getters.packagePriceWithoutDiscount(current.product.id, addressId) * current.amount).toFixed(2))
                return parseFloat(previous)
            }, 0)
        },
        totalDiscount: (state, getters) => {
            return state.weekCart.reduce((previous, current) => {
                previous = previous + parseFloat((getters.packagePriceDiscount(current.product.id, current.dayInWeek, current.addressId) * current.amount).toFixed(2))
                return parseFloat(previous)
            }, 0)
        },
        offDays: (state) => {
            return state.offDays
        }
    }
}
